import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange, handleSqsMessageBatchSizeChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { awsSecurityLakeThrottleEnabled, awsSecurityLakeStoreFullMessage, sqsMessageBatchSize } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  const internalHandleSqsBatchSizeChange = (e) => {
    const { value } = e.target;
    onChange(e, formData);
    if (value >= 1 && value <= 10) {
      handleSqsMessageBatchSizeChange("");
    } else {
      handleSqsMessageBatchSizeChange("Please select SQS Message Batch Size between 1 - 10.");
    }
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "awsSecurityLakeThrottleEnabled",
      defaultChecked: awsSecurityLakeThrottleEnabled == null ? void 0 : awsSecurityLakeThrottleEnabled.value,
      onChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "awsSecurityLakeStoreFullMessage",
      type: "checkbox",
      value: "enable-storeFullMessage",
      defaultChecked: awsSecurityLakeStoreFullMessage == null ? void 0 : awsSecurityLakeStoreFullMessage.value,
      onChange,
      label: "Store Full Message",
      help: "Store the full original Security Lake message as full_message?"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "sqsMessageBatchSize",
      type: "number",
      min: "1",
      value: sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value,
      onChange: internalHandleSqsBatchSizeChange,
      label: "SQS Message Batch Size",
      help: "The maximum number of messages to query from SQS at a time. The maximum acceptable value is 10."
    }
  ));
};
export default FormAdvancedOptions;
